// window.$ = window.jQuery = require('jquery');

// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
import observeAndExecute from './utils/observe-and-execute';
const fCarousels = require('./components/carousels');
const fNav = require('./components/nav');
const fSelect = require('./components/select');
const fMemberPopup = require('./components/member-popup');
const fGsapController = require('./components/gsap-controller')
import VueComponents from "./components/vue-components";

async function loadAOS() {
    const AOS = await (await import("aos")).default;
    AOS.init({
        once: true,
        offset: window.innerWidth >= 1024 ? -100 : 200,
        duration: 700,
    })
}

document.addEventListener("DOMContentLoaded", function () {
    fSmoothScroll()
    fNav();
    fMemberPopup();
    fSelect.init();
    fGsapController.init()

    new VueComponents({
        components: [
            {name: 'properties', file: () => import('./vue/features/properties/properties.vue')},
            {name: 'news', file: () => import('./vue/features/news/news.vue')},
        ],
    });
    
    observeAndExecute("[data-aos]", {
        callback: () => loadAOS(),
        disconnect: true,
    })
    
    observeAndExecute("[data-image-bg]", {
      callback: el => {
          el.style.backgroundImage = `url("${el.dataset.imageBg}")`
      }  
    })
    
    observeAndExecute(".swiper", {
        callback: () => fCarousels.init(),
    })
})